export const localeRegex = /^\w{2}-\w{2}$/;
